import { render, staticRenderFns } from "./DetallePermiso.vue?vue&type=template&id=0e6f3299"
import script from "./DetallePermiso.vue?vue&type=script&lang=js"
export * from "./DetallePermiso.vue?vue&type=script&lang=js"
import style0 from "./DetallePermiso.vue?vue&type=style&index=0&id=0e6f3299&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports